import './App.css';
import Router from './Route/Router';

function App() {
  return (
    <div className="app">
        <Router />
    </div>
  );
}

export default App;
